export default __webpack_public_path__ + "static/icon-f64bb341d2e97ecadd3710c08cec1a91.png";